'use strict';

import CheckoutProgress from './components/CheckoutProgress.vue';

export default class {

  constructor() {
    // Register component globaly
    Vue.component('checkout-progress', CheckoutProgress);
  }
}
